import { Link } from "react-router-dom";

const highlights = [
  {
    icon: "ri-radar-line",
    title: "每日发现新作品",
    text: "紧跟 AI 短剧更新节奏，第一时间收录新上线作品与创作团队动态。",
  },
  {
    icon: "ri-book-marked-line",
    title: "完整剧情与背景",
    text: "每部短剧都配有剧情简介、创作背景与主创信息，看前先了解再决定。",
  },
  {
    icon: "ri-filter-3-line",
    title: "多维筛选定位",
    text: "按类型、年份、标签组合筛选，配合热度与评分排序，快速找到你的口味。",
  },
];

export default function SiteIntro() {
  return (
    <section className="w-full bg-background-100">
      <div className="mx-auto w-full max-w-7xl px-4 py-14 md:px-8 md:py-20">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-2 lg:gap-16">
          <div>
            <span className="inline-flex items-center gap-1.5 text-xs font-semibold uppercase tracking-[0.18em] text-accent-600">
              <span className="h-1 w-1 rounded-full bg-accent-500"></span>
              About ai短剧
            </span>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              关于这个平台
            </h2>
            <p className="mt-5 text-sm leading-relaxed text-foreground-600 md:text-base">
              ai短剧是一个聚焦人工智能创作短剧的内容推荐与资讯聚合平台。我们不做播放，
              只做一件事——帮你从每天涌现的新作品中，快速找到值得花十几分钟去看的那一部。
            </p>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
              站内所有短剧、资讯、主创姓名均为虚构示例，用于展示平台的内容组织方式与浏览体验。
            </p>
            <Link
              to="/about"
              className="mt-7 inline-flex items-center gap-2 rounded-md bg-primary-500 px-5 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-information-line text-lg"></i>
              <span className="whitespace-nowrap">了解更多</span>
            </Link>
          </div>

          <div className="grid grid-cols-1 gap-4 sm:grid-cols-1">
            {highlights.map((item) => (
              <div
                key={item.title}
                className="flex gap-4 rounded-lg border border-background-200 bg-background-50 p-5"
              >
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-secondary-100 text-secondary-700">
                  <i className={`${item.icon} text-xl`}></i>
                </span>
                <div>
                  <h3 className="font-heading text-base font-semibold text-foreground-950">
                    {item.title}
                  </h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-foreground-500">{item.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}